import { FC, useState } from 'react'

import { ContactAdditionalRow } from '../contactAdditionalRow/ContactAdditionalRow'

import { IContactDataRowProps } from './models'

export const ContactDataRow: FC<IContactDataRowProps> = ({
  rowAttrs,
  renderChildren,
  contact,
  rowState,
  additional,
  colsNumber,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <>
      <tr {...rowAttrs} onClick={() => setIsOpen((oldValue) => !oldValue)}>
        {renderChildren(contact, rowState, additional)}
      </tr>
      {isOpen && (
        <tr>
          <td colSpan={colsNumber}>
            <ContactAdditionalRow contactId={contact.ContactID} contact={contact} />
          </td>
        </tr>
      )}
    </>
  )
}
